import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ErrorD } from 'src/app/base/interfaces/error';
import { InvocaService } from 'src/app/base/services/invoca.service';
import { Curso } from '../interfaces/curso';
import { Postulante } from '../interfaces/postulante';

@Injectable({
  providedIn: 'root'
})
export class SessionService implements CanActivate{

    constructor( private router: Router ){

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  boolean {
            
        if (!this.isLogged()) {
          this.router.navigate(['/unauthorized']);
          return false;
        }
    
        return true;
    }

    public isLogged(){
        return this.getToken() && this.getUser() ? true : false;
    }

    public setToken(token: string){
        sessionStorage.setItem('token', token);
    }

    public getToken(){
        return sessionStorage.getItem('token');
    }

    public setUser(user: Postulante){
        sessionStorage.setItem('user', JSON.stringify(user));
    }

    public getUser(){
        return JSON.parse(sessionStorage.getItem('user'));
    }

    public logout(){
        sessionStorage.clear();
        this.router.navigate(['/']);
    }
  
}
